import { OGRN_ZERO_ERROR } from '../constants/validationErrors';
import { KnmSubjectTypesEnum } from '../../../KnmErknmPackage/ErknmSubjectModule/components/ErknmSubjectInfo';

export function makeIsOgrn<T>(errorMsg: T, subjectType?: string) {
  return (value?: string) => {
    if (value) {
      if (value[0] === '0') {
        return OGRN_ZERO_ERROR;
      }

      return checkOgrnBySubjectType(subjectType, value) ? undefined : errorMsg;
    }
  };
}

export function checkOgrnBySubjectType(subjectTypeValue: string | undefined, ogrnValue: string | null) {
  if (!ogrnValue) {
    return false;
  }

  const has15digits = /^[\d+]{15}$/.test(ogrnValue);

  // Для ИП проверка на 15 символов
  if (subjectTypeValue === KnmSubjectTypesEnum.IP && has15digits) {
    return true;
  }

  // Для ЮЛ проверка на 13 символов
  const has13Digits = /^[\d+]{13}$/.test(ogrnValue);

  if (subjectTypeValue === KnmSubjectTypesEnum.UR && has13Digits) {
    return true;
  }

  return !subjectTypeValue && (has13Digits || has15digits);
}

const GENERAL_PROSECUTOR_ORGANIZATION_OGRN = '1037739514196';

export function isGeneralProsecutorOGRN(ogrn?: string): boolean {
  if (ogrn) {
    return ogrn === GENERAL_PROSECUTOR_ORGANIZATION_OGRN;
  }

  return false;
}
